import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function IPerfSource() {
    return (
        <React.Fragment>
            <p>
                Once a destination server is running, iPerf can be used on the source machine to test transfer speed and
                bandwidth between a Media Shuttle user and an SDCX server, or between two SDCX servers.
            </p>
            <p>To test connection speeds using iPerf:</p>
            <ol>
                <li>
                    Download and install <a href="https://iperf.fr">iPerf</a> on the server.
                    <br />
                </li>
                <li>
                    Open the terminal or command line.
                    <br />
                    <br />
                    <strong>Note</strong>: If testing between SDCX servers, connect to the server using SSH or another
                    remote access tool.
                    <br />
                    <br />
                </li>

                <li>
                    Start iPerf in client mode, and configure test parameters as required: <br />
                    <br />
                    <code className="language-text">
                        iperf3 -c {'<destination>'} -u -p {'<port>'} -t {'<duration>'} -i 2 -b {'<bandwidth>'}
                    </code>
                    <br />
                </li>
            </ol>
            <h3>Command Reference</h3>
            <ul>
                <li>
                    <code className="language-text">-c</code> - sets iPerf to run as a client
                </li>

                <li>
                    <code className="language-text">{'<destination>'}</code> - sets the destination server IP
                </li>

                <li>
                    <code className="language-text">-u</code> - sets the transfer protocol to UDP
                </li>

                <li>
                    <code className="language-text">-p {'<port>'}</code> - sets the destination port (49321 or 50221)
                </li>

                <li>
                    <code className="language-text">-t {'<duration>'}</code> - sets the test duration
                </li>

                <li>
                    <code className="language-text">-i 2</code> - sets the interval in seconds between bandwidth reports
                    (2 seconds)
                </li>

                <li>
                    <code className="language-text">-b {'<bandwidth>'}</code> - sets the bandwidth allocated to the test
                </li>
            </ul>
            <h3>Command Example</h3>
            <code className="language-text">iperf3 -c 203.0.113.4 -u -p 49221 -t 60 -i 2 -b 100M</code>
            <br /> <br />
            <p>
                You can also use the <code className="language-text">-n</code> option to set a specific total transfer
                size instead of a transfer time:
            </p>
            <br />
            <code className="language-text">iperf3 -c 203.0.113.4 -u -p 49221 -n 2056M -i 2 -b 100M</code>
            <br />
        </React.Fragment>
    );
}

IPerfSource.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IPerfSource);
